import { PREVIEW, RETRY } from "../actions/faceCapture";

export function faceCapture(state = {
  retries: 0
}, action) {
  switch (action.type) {
    case PREVIEW:
      return {
        ...state,
        ...action.payload
      };
    case RETRY:
      return {
        ...state,
        retries: state.retries + 1
      }
    default:
      return state;
  }
}